import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getIcardRequestsReport: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_ICARD_REQUESTS_REPORT_START,
    payload: params,
  }),
  getIcardRequestsReportSuccess: (data: any) => ({
    type: actionTypes.GET_ICARD_REQUESTS_REPORT_SUCCESS,
    payload: data,
  }),
  getIcardRequestsReportFinish: () => ({
    type: actionTypes.GET_ICARD_REQUESTS_REPORT_FINISH,
  }),
}
